export type ShoppingSummary = {
  merchantShoppingSummary: {
    cartCount: number;
    catalogCount: number;
  };
};

export enum MerchantFulfillmentStatus {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}
